import { dateTimeFormat } from '@/configs/dateFormat';
import { EOrderStatus } from '@/enums/EOrder';
import { EShippingType } from '@/enums/EShippingType';
import { getOrderStatusColor } from '@/helpers/orderHelper';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const FooterUpdate = ({
  title,
  actionBy,
  actionDate,
  status,
  transport,
}: {
  title?: string;
  actionBy?: string;
  actionDate?: Date | Dayjs | string;
  status: EOrderStatus;
  transport?: EShippingType;
}) => {
  const statusColor = getOrderStatusColor(status, transport);
  return (
    <div
      className={twMerge(
        'p-1 px-2 rounded-md flex flex-col w-full md:max-w-[250px] md:min-w-[250px]',
        statusColor.bg,
        statusColor.text,
      )}
    >
      <div className="flex flex-row justify-between w-full">
        <div className="flex">{title}</div>
      </div>
      <div className="flex flex-row justify-between w-full">
        <div className="flex">{actionBy}</div>
        <div className="flex">{`${(actionDate && dayjs(actionDate || null).format(dateTimeFormat)) || ''}`}</div>
      </div>
    </div>
  );
};

export default FooterUpdate;
